import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { _t } from "@/lib/i18n";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getCookieConsent, saveCookieConsent, applyCookieConsent } from "@/lib/cookieConsent";

export const CookieBanner = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(!getCookieConsent());
  const [custom, setCustom] = useState(false);
  const [stats, setStats] = useState(getCookieConsent()?.statistics ?? false);

  useEffect(() => {
    applyCookieConsent(getCookieConsent());
    const reopen = () => { setCustom(true); setOpen(true); };
    window.addEventListener("tc-open-cookies", reopen);
    return () => window.removeEventListener("tc-open-cookies", reopen);
  }, []);

  const choose = (statistics, choice) => {
    saveCookieConsent(statistics, choice);
    if (user) api.put("/auth/me/cookies", { statistics, choice }).catch(() => {});
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div className="fixed bottom-16 md:bottom-4 right-4 left-4 md:left-auto md:w-[26rem] z-[70]">
    <div data-testid="cookie-banner" className="tc-card p-5 border border-white/15 bg-[#0B0B0F]/95 backdrop-blur-xl shadow-2xl">
      <div className="flex items-center gap-2 text-white mb-2"><Cookie className="w-4 h-4 text-[#FF5722]" /><span className="font-medium">{_t("Cookie")}</span></div>
      <p className="text-xs text-white/65 leading-relaxed mb-4">{_t("Usiamo cookie tecnici necessari per l'accesso e la sicurezza. Con il tuo consenso usiamo anche cookie statistici anonimi per migliorare il sito.")}{" "}<a href="/sicurezza" className="underline text-white/80">{_t("Privacy")}</a></p>
      {custom && (
        <div className="space-y-2 mb-4 text-sm" data-testid="cookie-custom-panel">
          <label className="flex items-center justify-between text-white/60"><span>{_t("Necessari (sempre attivi)")}</span><input type="checkbox" checked disabled /></label>
          <label className="flex items-center justify-between text-white/85 cursor-pointer"><span>{_t("Statistiche")}</span><input data-testid="cookie-statistics-toggle" type="checkbox" checked={stats} onChange={(e) => setStats(e.target.checked)} /></label>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <button data-testid="cookie-accept-all" onClick={() => choose(true, "all")} className="btn-launch px-4 py-2 text-xs">{_t("Accetta tutti")}</button>
        <button data-testid="cookie-necessary-only" onClick={() => choose(false, "necessary")} className="px-4 py-2 text-xs rounded-full border border-white/20 text-white/80 hover:border-white/50">{_t("Solo necessari")}</button>
        {custom
          ? <button data-testid="cookie-save-custom" onClick={() => choose(stats, "custom")} className="px-4 py-2 text-xs rounded-full border border-[#FF5722]/60 text-[#FF5722]">{_t("Salva scelte")}</button>
          : <button data-testid="cookie-customize" onClick={() => setCustom(true)} className="px-4 py-2 text-xs text-white/60 underline">{_t("Personalizza")}</button>}
      </div>
    </div>
    </div>
  );
};

export const CookiePrefsButton = () => (
  <button data-testid="cookie-prefs-button" title={_t("Preferenze cookie")} aria-label={_t("Preferenze cookie")}
    onClick={() => window.dispatchEvent(new Event("tc-open-cookies"))}
    className="inline-flex items-center rounded-full border border-white/15 p-1.5 text-white/70 hover:border-[#FF5722] transition-colors">
    <Cookie className="w-3.5 h-3.5" />
  </button>
);
